// gavion.email.performance.* — GAVION sequence-performance: the « Performance » tab of a sequence (FR/EN parity is
// tested globally).
export const performanceMessages = {
  fr: {
    tab_settings: "Réglages",
    tab_performance: "Performance",
    tabs_label: "Vues de la séquence",
    list_link: "Performance",
    list_link_label: "Performance de %{name}",
    title: "Performance de la campagne",
    generated: "Calculé le %{time}",
    unavailable: "Statistiques indisponibles.",
    empty:
      "Aucun envoi pour l'instant : les statistiques apparaîtront après les premiers courriels.",
    small_sample_banner:
      "Échantillon trop petit (moins de 30 envois) — ne tirez pas de conclusions.",
    small_sample_flag: "Moins de 30 envois : taux peu fiable",
    small_sample_mark: "peu fiable",
    opened_note:
      "Les ouvertures probablement automatiques (Apple Mail, antivirus) ne comptent jamais comme des ouvertures (%{count} exclue(s)).",
    clicked_note:
      "Les clics des robots de sécurité (moins de 3 minutes après l'envoi, ou antivirus connu) ne comptent jamais comme des clics (%{count} exclu(s)).",
    versions: {
      title: "Versions du courriel",
      note: "Chaque objet réellement envoyé à une étape, côte à côte. Comparez surtout les réponses et les démos.",
      step: "Étape",
      subject: "Objet",
      period: "Période",
      period_value: "du %{from} au %{to}",
      sent: "Envoyés",
      opened: "Ouverts",
      clicked: "Vrais clics",
      replied: "Réponses",
      positive: "Démos",
      empty: "Aucun envoi pour l'instant.",
    },
    kpi: {
      label: "Indicateurs clés",
      sent: "Envoyés",
      sent_hint: "%{contacted} compagnies jointes sur %{enrolled} inscrites",
      open_rate: "Taux d'ouverture",
      click_rate: "Taux de clic",
      reply_rate: "Taux de réponse",
      people_hint: "%{count} compagnies sur %{base} jointes",
      unsubscribed: "Désabonnements",
      bounced: "Rebonds",
      on_sent_hint: "%{rate} des envois",
      demo_booked: "Démos réservées",
      in_pipeline: "En pipeline",
      won: "Gagnés",
      outcome_hint: "sur %{companies} compagnies",
    },
    status: {
      title: "Inscriptions",
      active: "Actives : %{count}",
      completed: "Terminées : %{count}",
      stopped: "Arrêtées : %{count}",
      reasons: "Motifs d'arrêt",
    },
    stop_reasons: {
      reply: "Réponse reçue",
      unsubscribe: "Désabonnement",
      bounce: "Rebond",
      complaint: "Plainte",
      not_interested: "Pas intéressé",
      demo_booked: "Démo réservée",
      in_pipeline: "En pipeline",
      deal_created: "Deal créé",
      deal_stage_changed: "Changement d'étape du deal",
      do_not_call: "Ne pas appeler",
      customer: "Devenu client",
      won: "Deal gagné",
      lost: "Deal perdu",
      merged: "Fiche fusionnée",
      rep_cancel: "Retiré par le représentant",
      disabled: "Séquence désactivée",
      erased: "Données effacées",
      replaced_by_ai: "Remplacée par un suivi IA",
    },
    conclusions: {
      title: "Conclusions",
      none: "Rien de net pour l'instant : continuez les envois.",
      small_sample:
        "Seulement %{sent} envois : il en faut au moins %{min} avant de tirer des conclusions.",
      nominative_better:
        "Les adresses nominatives répondent %{ratio}× plus que les adresses génériques (info@, contact@…).",
      nominative_only:
        "Seules les adresses nominatives répondent (%{rate} %) ; les adresses génériques (info@…) n'ont rien donné.",
      generic_better:
        "Les adresses génériques (info@…) répondent %{ratio}× plus que les adresses nominatives.",
      generic_only: "Seules les adresses génériques ont répondu (%{rate} %).",
      best_step_reply:
        "Le courriel %{step} (%{name}) a le meilleur taux de réponse : %{rate} %.",
      best_step_open:
        "Aucune réponse encore ; le courriel %{step} (%{name}) est le plus ouvert : %{rate} %.",
      worst_step:
        "Le courriel %{step} (%{name}) est le plus faible : %{reply} % de réponses, %{open} % d'ouvertures. À réécrire ou à retirer.",
      step_unsubscribes:
        "Le courriel %{step} (%{name}) fait décrocher : %{count} désabonnements (%{rate} %).",
      high_bounce:
        "Trop de rebonds (%{rate} %, %{count}) : nettoyez la liste avant d'inscrire d'autres compagnies.",
      low_open:
        "Peu d'ouvertures (%{rate} %) : essayez un autre objet ou vérifiez la délivrabilité.",
      opens_no_replies:
        "On ouvre (%{open} %) mais on ne répond pas (%{reply} %) : retravaillez le message et l'appel à l'action.",
      best_sector: "Meilleur secteur : « %{sector} » (%{rate} % de réponses).",
      best_weekday:
        "Meilleur jour d'envoi : %{day} (%{rate} % de réponses, %{open} % d'ouvertures).",
      best_hour:
        "Meilleure heure d'envoi : %{hour} (%{rate} % de réponses, %{open} % d'ouvertures).",
      demos:
        "%{smart_count} démo réservée après la campagne, sur %{companies} compagnies (affaires gagnées : %{won}). |||| %{smart_count} démos réservées après la campagne, sur %{companies} compagnies (affaires gagnées : %{won}).",
    },
    steps: {
      title: "Quel courriel fonctionne",
      step: "Étape",
      email: "Courriel",
      sent: "Envoyés",
      opened: "Ouverts",
      clicked: "Cliqués",
      replied: "Réponses",
      unsubscribed: "Désabonnements",
      bounced: "Rebonds",
      best: "Meilleur",
      worst: "Le plus faible",
      no_template: "Modèle supprimé",
      note: "Taux sur les envois de l'étape. Meilleur et plus faible : taux de réponse, puis taux d'ouverture.",
    },
    funnel: {
      title: "Entonnoir",
      note: "Par compagnie, seulement ce qui s'est passé après son inscription.",
      enrolled: "Inscrites",
      opened: "Ont ouvert",
      clicked: "Ont cliqué",
      replied: "Ont répondu",
      demo: "Démo réservée",
      pipeline: "En pipeline",
      won: "Gagné",
      not_interested: "Pas intéressées : %{count}",
    },
    breakdowns: {
      title: "Qui répond, et quand",
      note: "Taux sur les compagnies jointes. « Démo ou plus » : démo réservée, pipeline ou gagné après l'inscription.",
      empty: "Aucune donnée.",
      value: "Valeur",
      enrolled: "Inscrits",
      contacted: "Joints",
      opened: "Ont ouvert",
      replied: "Ont répondu",
      positive: "Démo ou plus",
      not_given: "Non précisé",
      dims: {
        addressKind: "Type d'adresse",
        sector: "Secteur",
        region: "Région",
        city: "Ville",
        weekday: "Jour du premier envoi",
        hour: "Heure du premier envoi (Toronto)",
        openDelay: "Délai avant la première ouverture",
      },
      kinds: {
        nominative: "Nominative (prénom@entreprise)",
        generic: "Générique (info@, contact@…)",
        webmail: "Webmail gratuit (gmail, hotmail…)",
      },
      weekdays: {
        "1": "Lundi",
        "2": "Mardi",
        "3": "Mercredi",
        "4": "Jeudi",
        "5": "Vendredi",
        "6": "Samedi",
        "7": "Dimanche",
      },
      hour: "%{hour} h",
      delays: {
        lt_1h: "Moins d'1 h",
        h1_24: "1 à 24 h",
        d1_3: "1 à 3 jours",
        gt_3d: "Plus de 3 jours",
        not_opened: "Pas ouvert",
      },
    },
    timeline: {
      title: "Jour par jour (Toronto)",
      empty: "Aucune activité.",
      sent: "Envoyés",
      opened: "Ouverts",
      replied: "Réponses",
      day_label:
        "%{day} : %{sent} envoyés, %{opened} ouverts, %{replied} réponses",
    },
    recent: {
      title: "Activité récente",
      empty: "Aucune activité.",
      step: "Étape %{n}",
      hidden_company: "Compagnie non visible",
      kinds: {
        open: "A ouvert",
        click: "A cliqué",
        reply: "A répondu",
        unsubscribe: "S'est désabonné",
        bounce: "Rebond",
        complaint: "Plainte (spam)",
      },
    },
  },
  en: {
    tab_settings: "Settings",
    tab_performance: "Performance",
    tabs_label: "Sequence views",
    list_link: "Performance",
    list_link_label: "Performance of %{name}",
    title: "Campaign performance",
    generated: "Computed on %{time}",
    unavailable: "Statistics unavailable.",
    empty: "Nothing sent yet: statistics appear after the first emails.",
    small_sample_banner:
      "Sample too small (fewer than 30 sends) — do not draw conclusions.",
    small_sample_flag: "Fewer than 30 sends: unreliable rate",
    small_sample_mark: "unreliable",
    opened_note:
      "Probably automatic opens (Apple Mail, security scanners) never count as opens (%{count} excluded).",
    clicked_note:
      "Clicks by security robots (under 3 minutes after the send, or a known scanner) never count as clicks (%{count} excluded).",
    versions: {
      title: "Email versions",
      note: "Each subject actually sent at a step, side by side. Compare replies and demos first.",
      step: "Step",
      subject: "Subject",
      period: "Period",
      period_value: "%{from} to %{to}",
      sent: "Sent",
      opened: "Opened",
      clicked: "Real clicks",
      replied: "Replies",
      positive: "Demos",
      empty: "No sends yet.",
    },
    kpi: {
      label: "Key figures",
      sent: "Sent",
      sent_hint: "%{contacted} companies reached out of %{enrolled} enrolled",
      open_rate: "Open rate",
      click_rate: "Click rate",
      reply_rate: "Reply rate",
      people_hint: "%{count} companies out of %{base} reached",
      unsubscribed: "Unsubscribes",
      bounced: "Bounces",
      on_sent_hint: "%{rate} of sends",
      demo_booked: "Demos booked",
      in_pipeline: "In pipeline",
      won: "Won",
      outcome_hint: "out of %{companies} companies",
    },
    status: {
      title: "Enrolments",
      active: "Active: %{count}",
      completed: "Completed: %{count}",
      stopped: "Stopped: %{count}",
      reasons: "Stop reasons",
    },
    stop_reasons: {
      reply: "Reply received",
      unsubscribe: "Unsubscribe",
      bounce: "Bounce",
      complaint: "Complaint",
      not_interested: "Not interested",
      demo_booked: "Demo booked",
      in_pipeline: "In pipeline",
      deal_created: "Deal created",
      deal_stage_changed: "Deal stage changed",
      do_not_call: "Do not call",
      customer: "Became a customer",
      won: "Deal won",
      lost: "Deal lost",
      merged: "Record merged",
      rep_cancel: "Removed by the rep",
      disabled: "Sequence disabled",
      erased: "Data erased",
      replaced_by_ai: "Replaced by an AI follow-up",
    },
    conclusions: {
      title: "Conclusions",
      none: "Nothing clear yet: keep sending.",
      small_sample:
        "Only %{sent} sends: at least %{min} are needed before drawing conclusions.",
      nominative_better:
        "Named addresses reply %{ratio}× more than generic ones (info@, contact@…).",
      nominative_only:
        "Only named addresses reply (%{rate} %); generic addresses (info@…) gave nothing.",
      generic_better:
        "Generic addresses (info@…) reply %{ratio}× more than named ones.",
      generic_only: "Only generic addresses replied (%{rate} %).",
      best_step_reply:
        "Email %{step} (%{name}) has the best reply rate: %{rate} %.",
      best_step_open:
        "No replies yet; email %{step} (%{name}) is the most opened: %{rate} %.",
      worst_step:
        "Email %{step} (%{name}) is the weakest: %{reply} % replies, %{open} % opens. Rewrite or remove it.",
      step_unsubscribes:
        "Email %{step} (%{name}) drives people away: %{count} unsubscribes (%{rate} %).",
      high_bounce:
        "Too many bounces (%{rate} %, %{count}): clean the list before enrolling more companies.",
      low_open:
        "Few opens (%{rate} %): try another subject or check deliverability.",
      opens_no_replies:
        "People open (%{open} %) but do not reply (%{reply} %): rework the message and the call to action.",
      best_sector: "Best sector: “%{sector}” (%{rate} % replies).",
      best_weekday:
        "Best sending day: %{day} (%{rate} % replies, %{open} % opens).",
      best_hour:
        "Best sending hour: %{hour} (%{rate} % replies, %{open} % opens).",
      demos:
        "%{smart_count} demo booked after the campaign, out of %{companies} companies (deals won: %{won}). |||| %{smart_count} demos booked after the campaign, out of %{companies} companies (deals won: %{won}).",
    },
    steps: {
      title: "Which email works",
      step: "Step",
      email: "Email",
      sent: "Sent",
      opened: "Opened",
      clicked: "Clicked",
      replied: "Replies",
      unsubscribed: "Unsubscribes",
      bounced: "Bounces",
      best: "Best",
      worst: "Weakest",
      no_template: "Template deleted",
      note: "Rates on the step's sends. Best and weakest: reply rate, then open rate.",
    },
    funnel: {
      title: "Funnel",
      note: "Per company, only what happened after its enrolment.",
      enrolled: "Enrolled",
      opened: "Opened",
      clicked: "Clicked",
      replied: "Replied",
      demo: "Demo booked",
      pipeline: "In pipeline",
      won: "Won",
      not_interested: "Not interested: %{count}",
    },
    breakdowns: {
      title: "Who replies, and when",
      note: "Rates on companies reached. “Demo or better”: demo booked, pipeline or won after the enrolment.",
      empty: "No data.",
      value: "Value",
      enrolled: "Enrolled",
      contacted: "Reached",
      opened: "Opened",
      replied: "Replied",
      positive: "Demo or better",
      not_given: "Not given",
      dims: {
        addressKind: "Address type",
        sector: "Sector",
        region: "Region",
        city: "City",
        weekday: "Day of the first send",
        hour: "Hour of the first send (Toronto)",
        openDelay: "Time to first open",
      },
      kinds: {
        nominative: "Named (firstname@company)",
        generic: "Generic (info@, contact@…)",
        webmail: "Free webmail (gmail, hotmail…)",
      },
      weekdays: {
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        "7": "Sunday",
      },
      hour: "%{hour}:00",
      delays: {
        lt_1h: "Under 1 h",
        h1_24: "1 to 24 h",
        d1_3: "1 to 3 days",
        gt_3d: "Over 3 days",
        not_opened: "Not opened",
      },
    },
    timeline: {
      title: "Day by day (Toronto)",
      empty: "No activity.",
      sent: "Sent",
      opened: "Opened",
      replied: "Replies",
      day_label: "%{day}: %{sent} sent, %{opened} opened, %{replied} replies",
    },
    recent: {
      title: "Recent activity",
      empty: "No activity.",
      step: "Step %{n}",
      hidden_company: "Company not visible",
      kinds: {
        open: "Opened",
        click: "Clicked",
        reply: "Replied",
        unsubscribe: "Unsubscribed",
        bounce: "Bounce",
        complaint: "Complaint (spam)",
      },
    },
  },
} as const;
